import { useNavigate } from "react-router-dom";
import { useBreadcrumb } from "hooks/useBreadcrumb";
export default function AccessDenied() {
  const navigate = useNavigate();
  useBreadcrumb([]);
  return (
    <>
      <div className="container">
        <div>
          <h1 className="text-xl font-bold tracking-tight text-gray-900">
            You are not authorized to access this page
          </h1>
        </div>
        <div className="pt-6">
          <button className="ui-btn-secondary" onClick={() => navigate(-1)}>
            Back to Previous page
          </button>
        </div>
      </div>
    </>
  );
}
